// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar {
  width: 100%;
  color: white;
  font-family: "Plus Jakarta Sans", sans-serif;
}

/* Clear duplicate inner padding from the container */
.sidebarContainer {
  padding: 0 !important;
  margin: 0;
  display: flex;
  flex-direction: column;
}

/* User profile card styling */
.userProfileDetails {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background-color: rgba(255, 255, 255, 0.02);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  margin-top: 20px;
  margin-bottom: 10px;
}

.profileImageContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.profileImage {
  height: 36px;
  width: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 1.5px solid rgba(90, 175, 154, 0.3);
}

.userNameContainer {
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow: hidden;
}

.userName {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  text-transform: capitalize;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.userEmail {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Menu list spacing */
.sidebarMenuContainer {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Sleek Menu Button Styling */
.savedBtnContainer {
  all: unset;
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: rgba(255, 255, 255, 0.08) !important; /* Uniform background color for elements */
  box-sizing: border-box;
  padding: 12px 16px !important;
  border-radius: 12px !important;
  cursor: pointer;
  width: 100% !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  color: rgba(255, 255, 255, 0.75) !important;
}

/* Hover state: subtle grey highlight, highlight icon to teal */
.savedBtnContainer:hover {
  background-color: rgba(255, 255, 255, 0.14) !important;
  color: #ffffff !important;
}

.savedBtnContainer:hover svg {
  color: #5AAF9A !important;
  transform: translateX(2px);
  transition: transform 0.2s ease;
}

/* Active state: teal highlight tint */
.savedBtnContainer.active {
  background-color: rgba(90, 175, 154, 0.12) !important;
  color: #5AAF9A !important;
  font-weight: 500 !important;
}

.savedBtnContainer.active svg {
  color: #5AAF9A !important;
}

.sidebarHeadingText {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.2px;
}

.selectedSidebarHeadingText {
  color: #5AAF9A !important;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.2px;
}

/* Style overrides for Material UI Accordion */
.Sidebar .MuiAccordion-root {
  background-color: rgba(255, 255, 255, 0.08) !important; /* Same background color as flat buttons */
  background: rgba(255, 255, 255, 0.08) !important;
  box-shadow: none !important;
  color: rgba(255, 255, 255, 0.75) !important;
  margin: 0 !important;
  border-radius: 12px !important;
  border: none !important;
  overflow: hidden !important;
}

.Sidebar .MuiAccordion-root:before {
  display: none !important;
}

.Sidebar .MuiAccordionSummary-root {
  background-color: transparent !important;
  min-height: 46px !important;
  height: 46px !important;
  padding: 0 16px !important;
  border-radius: 12px !important;
  transition: all 0.2s ease !important;
}

.Sidebar .MuiAccordionSummary-root:hover {
  background-color: rgba(255, 255, 255, 0.06) !important;
  color: #ffffff !important;
}

.Sidebar .MuiAccordionSummary-root:hover svg {
  color: #5AAF9A !important;
}

.Sidebar .MuiAccordionSummary-content {
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.myProfileHeading {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

/* Active style overrides when the wrapper container is active */
.myProfileDropdownContainer.active .MuiAccordion-root {
  background-color: rgba(90, 175, 154, 0.12) !important;
  background: rgba(90, 175, 154, 0.12) !important;
}

.myProfileDropdownContainer.active .MuiAccordionSummary-root {
  color: #5AAF9A !important;
}

.myProfileDropdownContainer.active .MuiAccordionSummary-root svg {
  color: #5AAF9A !important;
}

/* Accordion expanded sub-menu section - Flow unified in same background card */
.Sidebar .MuiAccordionDetails-root {
  padding: 4px 12px 12px 12px !important;
  background-color: transparent !important; /* Flow internally inside parent card */
  border-radius: 0 !important;
  margin: 0 !important;
  border: none !important;
}

/* Sub-menu Dropdown Buttons */
.dropdownBtnsContainer {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dropdownBtn {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  cursor: pointer;
  padding: 10px 14px;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.65);
  background: transparent;
  border: none;
  text-align: left;
  transition: all 0.2s ease;
  gap: 12px;
}

.selectedDropdownBtn {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  cursor: pointer;
  padding: 10px 14px;
  border-radius: 10px;
  color: #5AAF9A;
  background-color: rgba(90, 175, 154, 0.08);
  border: none;
  text-align: left;
  transition: all 0.2s ease;
  gap: 12px;
}

.dropdownBtn:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

.dropdownBtn:hover svg {
  color: #5AAF9A !important;
}

.dropdownBtn svg,
.selectedDropdownBtn svg {
  margin: 0 !important;
  font-size: 18px !important;
}

/* Fallback dot bullet for sub-items without icons */
.dropdownBtn:not(:has(svg))::before,
.selectedDropdownBtn:not(:has(svg))::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: currentColor;
  margin-left: 6px;
  margin-right: 6px;
  opacity: 0.8;
}

/* Clear responsive margins/paddings overrides */
@media (max-width: 1640px) {
  .sidebarContainer { padding: 0 !important; }
}
@media (max-width: 1440px) {
  .sidebarContainer { padding: 0 !important; }
}
@media (max-width: 1280px) {
  .sidebarContainer { padding: 0 !important; }
}
@media (max-width: 1024px) {
  .sidebarContainer { padding: 0 !important; }
}

/* Mobile responsive styles for sidebar */
@media (max-width: 768px) {
  .sidebarContainer {
    padding: 16px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,qDAAqD;AACrD;EACE,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sDAAsD,EAAE,0CAA0C;EAClG,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,4DAA4D;EAC5D,2CAA2C;AAC7C;;AAEA,+DAA+D;AAC/D;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,sCAAsC;AACtC;EACE,qDAAqD;EACrD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,sDAAsD,EAAE,0CAA0C;EAClG,gDAAgD;EAChD,2BAA2B;EAC3B,2CAA2C;EAC3C,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,sCAAsC;EACtC,wCAAwC,EAAE,uCAAuC;EACjF,2BAA2B;EAC3B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,oDAAoD;AACpD;;EAEE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,oBAAoB,qBAAqB,EAAE;AAC7C;AACA;EACE,oBAAoB,qBAAqB,EAAE;AAC7C;AACA;EACE,oBAAoB,qBAAqB,EAAE;AAC7C;AACA;EACE,oBAAoB,qBAAqB,EAAE;AAC7C;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap\");\n\n.Sidebar {\n  width: 100%;\n  color: white;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n/* Clear duplicate inner padding from the container */\n.sidebarContainer {\n  padding: 0 !important;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* User profile card styling */\n.userProfileDetails {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background-color: rgba(255, 255, 255, 0.02);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.profileImageContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profileImage {\n  height: 36px;\n  width: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1.5px solid rgba(90, 175, 154, 0.3);\n}\n\n.userNameContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  overflow: hidden;\n}\n\n.userName {\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n  text-transform: capitalize;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.userEmail {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.4);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n/* Menu list spacing */\n.sidebarMenuContainer {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Sleek Menu Button Styling */\n.savedBtnContainer {\n  all: unset;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background-color: rgba(255, 255, 255, 0.08) !important; /* Uniform background color for elements */\n  box-sizing: border-box;\n  padding: 12px 16px !important;\n  border-radius: 12px !important;\n  cursor: pointer;\n  width: 100% !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n\n/* Hover state: subtle grey highlight, highlight icon to teal */\n.savedBtnContainer:hover {\n  background-color: rgba(255, 255, 255, 0.14) !important;\n  color: #ffffff !important;\n}\n\n.savedBtnContainer:hover svg {\n  color: #5AAF9A !important;\n  transform: translateX(2px);\n  transition: transform 0.2s ease;\n}\n\n/* Active state: teal highlight tint */\n.savedBtnContainer.active {\n  background-color: rgba(90, 175, 154, 0.12) !important;\n  color: #5AAF9A !important;\n  font-weight: 500 !important;\n}\n\n.savedBtnContainer.active svg {\n  color: #5AAF9A !important;\n}\n\n.sidebarHeadingText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.2px;\n}\n\n.selectedSidebarHeadingText {\n  color: #5AAF9A !important;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n}\n\n/* Style overrides for Material UI Accordion */\n.Sidebar .MuiAccordion-root {\n  background-color: rgba(255, 255, 255, 0.08) !important; /* Same background color as flat buttons */\n  background: rgba(255, 255, 255, 0.08) !important;\n  box-shadow: none !important;\n  color: rgba(255, 255, 255, 0.75) !important;\n  margin: 0 !important;\n  border-radius: 12px !important;\n  border: none !important;\n  overflow: hidden !important;\n}\n\n.Sidebar .MuiAccordion-root:before {\n  display: none !important;\n}\n\n.Sidebar .MuiAccordionSummary-root {\n  background-color: transparent !important;\n  min-height: 46px !important;\n  height: 46px !important;\n  padding: 0 16px !important;\n  border-radius: 12px !important;\n  transition: all 0.2s ease !important;\n}\n\n.Sidebar .MuiAccordionSummary-root:hover {\n  background-color: rgba(255, 255, 255, 0.06) !important;\n  color: #ffffff !important;\n}\n\n.Sidebar .MuiAccordionSummary-root:hover svg {\n  color: #5AAF9A !important;\n}\n\n.Sidebar .MuiAccordionSummary-content {\n  margin: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.myProfileHeading {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n\n/* Active style overrides when the wrapper container is active */\n.myProfileDropdownContainer.active .MuiAccordion-root {\n  background-color: rgba(90, 175, 154, 0.12) !important;\n  background: rgba(90, 175, 154, 0.12) !important;\n}\n\n.myProfileDropdownContainer.active .MuiAccordionSummary-root {\n  color: #5AAF9A !important;\n}\n\n.myProfileDropdownContainer.active .MuiAccordionSummary-root svg {\n  color: #5AAF9A !important;\n}\n\n/* Accordion expanded sub-menu section - Flow unified in same background card */\n.Sidebar .MuiAccordionDetails-root {\n  padding: 4px 12px 12px 12px !important;\n  background-color: transparent !important; /* Flow internally inside parent card */\n  border-radius: 0 !important;\n  margin: 0 !important;\n  border: none !important;\n}\n\n/* Sub-menu Dropdown Buttons */\n.dropdownBtnsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dropdownBtn {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: \"Inter\", sans-serif;\n  cursor: pointer;\n  padding: 10px 14px;\n  border-radius: 10px;\n  color: rgba(255, 255, 255, 0.65);\n  background: transparent;\n  border: none;\n  text-align: left;\n  transition: all 0.2s ease;\n  gap: 12px;\n}\n\n.selectedDropdownBtn {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: \"Inter\", sans-serif;\n  cursor: pointer;\n  padding: 10px 14px;\n  border-radius: 10px;\n  color: #5AAF9A;\n  background-color: rgba(90, 175, 154, 0.08);\n  border: none;\n  text-align: left;\n  transition: all 0.2s ease;\n  gap: 12px;\n}\n\n.dropdownBtn:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n}\n\n.dropdownBtn:hover svg {\n  color: #5AAF9A !important;\n}\n\n.dropdownBtn svg,\n.selectedDropdownBtn svg {\n  margin: 0 !important;\n  font-size: 18px !important;\n}\n\n/* Fallback dot bullet for sub-items without icons */\n.dropdownBtn:not(:has(svg))::before,\n.selectedDropdownBtn:not(:has(svg))::before {\n  content: \"\";\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: currentColor;\n  margin-left: 6px;\n  margin-right: 6px;\n  opacity: 0.8;\n}\n\n/* Clear responsive margins/paddings overrides */\n@media (max-width: 1640px) {\n  .sidebarContainer { padding: 0 !important; }\n}\n@media (max-width: 1440px) {\n  .sidebarContainer { padding: 0 !important; }\n}\n@media (max-width: 1280px) {\n  .sidebarContainer { padding: 0 !important; }\n}\n@media (max-width: 1024px) {\n  .sidebarContainer { padding: 0 !important; }\n}\n\n/* Mobile responsive styles for sidebar */\n@media (max-width: 768px) {\n  .sidebarContainer {\n    padding: 16px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
